export default "__VITE_ASSET__CPud5FdE__"